import { isAfter, isEqual, isValid, parse } from 'date-fns';

import { ia } from 'lib/helpers/utility';

const validationChecks = (valList) => {
  const finalErrors = [];

  valList.forEach((val) => {
    const dayEntry = {
      day: val.day,
      location: { hasErrors: false, message: '' },
      virtual: { hasErrors: false, message: '' }
    };

    const entries = { ...val };
    delete entries.day;

    Object.entries(entries).forEach(([typeKey, value]) => {
      if (ia(value)) {
        checkBreaks(value, dayEntry);
      } else {
        checkTimes(value, dayEntry, typeKey);
      }
    });

    finalErrors.push(dayEntry);
  });

  return finalErrors;
};

function checkBreaks(value, dayEntry) {
  value.forEach((item) => {
    const starts = parse(String(item.starts_at), 'HH:mm a', new Date());
    const ends = parse(String(item.ends_at), 'HH:mm a', new Date());

    if (item.starts_at != null && item.ends_at == null) {
      setError(dayEntry, `Please add an end time`, item.id);
    }

    if (item.starts_at == null && item.ends_at != null) {
      setError(dayEntry, `Please add a start time`, item.id);
    }

    if (isValid(starts) && isValid(ends)) {
      if (isAfter(starts, ends)) {
        setError(dayEntry, `Start time can't be after end time`, item.id);
      }

      if (isEqual(starts, ends)) {
        setError(dayEntry, `Start time and end time can't be the same`, item.id);
      }
    }
  });
}

function checkTimes(value, dayEntry, typeKey) {
  const starts_at = parse(String(value.starts_at), 'HH:mm a', new Date());
  const ends_at = parse(String(value.ends_at), 'HH:mm a', new Date());

  if (value.starts_at != null && value.ends_at == null) {
    setError(dayEntry[typeKey], `Please add an end time`);
  }

  if (value.starts_at == null && value.ends_at != null) {
    setError(dayEntry[typeKey], `Please add a start time`);
  }

  if (isValid(starts_at) && isValid(ends_at)) {
    if (isAfter(starts_at, ends_at)) {
      setError(dayEntry[typeKey], `Start time can't be after end time`);
    }

    if (isEqual(starts_at, ends_at)) {
      setError(dayEntry[typeKey], `Start and end times can't be the same`);
    }
  }
}

function setError(entry, message, breakId = null) {
  if (breakId !== null) {
    if (!entry.breaks) entry.breaks = {};
    if (!entry.breaks[breakId]) {
      entry.breaks[breakId] = message;
    }
  } else {
    if (!entry.hasErrors) {
      entry.hasErrors = true;
      entry.message = message;
    }
  }
}

export default validationChecks;
